import React, { Component } from "react";
import { Button } from "antd";

import { UIFormSection, UIInfoBanner, UILabelHelp } from "../../../components";

import ModalRequest from "../request";

import "./styles.scss";

const FILES_CONFIG = [
  {
    key: "reppFile",
    field: "rep_p_file",
    label: "REP-P",
    help: "Registro Eletrônico de Ponto - Programa.",
    note: "Atestado de conformidade para o programa de registro eletrônico de ponto — Portaria 1.510/2009.",
  },
  {
    key: "ptrpFile",
    field: "ptrp_file",
    label: "PTRP",
    help: "Programa de Tratamento de Registro de Ponto.",
    note: "Atestado para o programa de tratamento de registros de ponto — Portaria 671/2021.",
  },
];

class Atestados extends Component {
  constructor(props) {
    super(props);

    this.state = {
      reppFile: null,
      ptrpFile: null,
      company: null,
      requestModalVisible: false,
    };
  }

  init = (item) => {
    if (!item) return;

    this.setState({ company: item });

    FILES_CONFIG.forEach(({ key, field }) => {
      const url = item[field];

      this.setState({
        [key]: url ? { url, type: this.getMimeType(url) } : null,
      });
    });
  };

  requestOpen = () => {
    this.setState({ requestModalVisible: true });

    // On open screen
    this.requestScreen && this.requestScreen.onOpen();
  };

  requestOnClose = () => {
    this.setState({ requestModalVisible: false });
  };

  getMimeType = (url) => {
    if (!url) return "application/octet-stream";

    const ext = url.split(".").pop().toLowerCase();

    switch (ext) {
      case "jpg":
      case "jpeg":
      case "png":
        return "image/" + (ext === "jpg" ? "jpeg" : ext);
      case "pdf":
        return "application/pdf";
      default:
        return "application/octet-stream";
    }
  };

  getFileExtension = (url) => {
    if (!url) return "";
    return url.split(".").pop().toUpperCase();
  };

  getFileName = (url) => {
    if (!url) return "";
    const parts = url.split("/");
    return parts[parts.length - 1];
  };

  handleDownload = (fileUrl, fileName) => {
    if (!fileUrl) return;

    const link = document.createElement("a");
    link.href = fileUrl;
    link.setAttribute("download", fileName);
    link.setAttribute("target", "_blank");
    document.body.appendChild(link);
    link.click();
    link.remove();
  };

  renderFile = (file) => {
    if (!file || !file.url) {
      return (
        <div className="atestado-file-empty">
          <i className="fal fa-file" />
          <span>Nenhum atestado anexado</span>
        </div>
      );
    }

    const isPdf = file.type === "application/pdf";
    const extension = this.getFileExtension(file.url);
    const fileName = this.getFileName(file.url);

    return (
      <div className="atestado-file-card">
        <div className={`atestado-file-icon ${isPdf ? "atestado-file-icon-pdf" : ""}`}>
          <i className={isPdf ? "fal fa-file-pdf" : "fal fa-file-image"} />
          <span className="atestado-file-extension">{extension}</span>
        </div>
        <div className="atestado-file-name" title={fileName}>{fileName}</div>
        <Button
          type="default"
          className="action-btn-secondary"
          icon={<i className="fal fa-download" />}
          onClick={() => this.handleDownload(file.url, fileName)}
        >
          Baixar
        </Button>
      </div>
    );
  };

  render() {
    const { reppFile, ptrpFile } = this.state;
    const files = { reppFile, ptrpFile };

    return (
      <>
        <UIFormSection
          icon={<i className="fal fa-file-certificate" />}
          title="Atestados de Software"
          description="Consulte e baixe os atestados de conformidade anexados ao sistema."
        >
          {FILES_CONFIG.map((config) => (
            <div className="atestado-section" key={config.key}>
              <div className="atestado-section-label">
                {config.label} <UILabelHelp content={config.help} />
              </div>
              {this.renderFile(files[config.key])}
              <div className="atestado-section-note">
                <i className="fal fa-info-circle" />
                <span>{config.note}</span>
              </div>
            </div>
          ))}
        </UIFormSection>
        <UIInfoBanner
          icon={<i className="fal fa-info-circle" />}
          title="Sobre os atestados"
          description={
            <>
              Os atestados são documentos obrigatórios para a utilização do sistema e devem estar sempre atualizados.
              {" "}Caso necessário, <a onClick={this.requestOpen}>clique aqui</a> para solicitar o atestado.
            </>
          }
        />
        <ModalRequest
          ref={(el) => (this.requestScreen = el)}
          visible={this.state.requestModalVisible}
          onClose={this.requestOnClose}
          company={this.state.company}
        />
      </>
    );
  }
}

export default Atestados;
